import React, { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { popupcontext } from "../../../context/Popupscontext";
import Loader from "../../Helpers/Loader/Loader";
import { useSelector } from "react-redux";
import trans, { isRTL } from "../../../utils";
import { useAddCustomerPermissionMutation } from "../../../Redux/service/Permissions/CustomerPermissions";
import { Segmented } from "antd";
import CustomerInfo from "./CustomerInfo";
import CustomerLocation from "./CustomerLocation";
import { OffcanvasBody } from "react-bootstrap";
import CustomerExtra from "./CustomerExtra";
import {
	useAddCustomerMutation,
	useEditCustomerMutation,
} from "../../../Redux/service/Customer/Customer";
import StepsOffcanvasFooter from "../../Helpers/Offcanvasfooter/StepsOffcanvasFooter";
export default function CustomerBody({ onSuccess, Editvalues, refetch }) {
	let { handleClose, isEditing, currentCustomerId, setReloadData } =
		useContext(popupcontext);
	const inf = useSelector((state) => state.users.user);
	const steps = [
		{ label: trans("information"), value: "information" },
		{ label: trans("location setup"), value: "location setup" },
		{ label: trans("extra"), value: "extra" },
	];
	const [activeOption, setActiveOption] = useState("information");

	const [submitAttempt, setSubmitAttempt] = useState(false);
	let [InsertCustomer, { isLoading: AddLoading }] = useAddCustomerMutation();
	let [EditUser, { isLoading: EditLoading }] = useEditCustomerMutation();
	let [AddPermission] = useAddCustomerPermissionMutation();

	let initialValues = {
		name: null,
		email: null,
		password: null,
		phoneNumber: null,
		address: null,
		fax: null,
		country: null,
		city: null,
		website: null,
		taxId: null,
		status: true,
		contactPerson: {
			name: null,
			phone: null,
			email: null,
		},
		customAttributes: null,
	};
	const passwordValidation = (password) =>
		isEditing
			? Yup.string().nullable()
			: Yup.string()
					.required(trans("Password Is Required"))
					.min(8, trans("Password must be at least 8 characters"));

	let validSchema = Yup.object({
		name: Yup.string()
			.required(trans("Name is required"))
			.min(3, trans("Name must be at least 3 characters"))
			.max(20, trans("Name must be at most 20 characters"))
			.matches(
				/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z0-9\s]+$/,
				trans("Name cannot contain special characters")
			)
			.test(
				"no-leading-space",
				trans("Name cannot start with a space"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/^\s/.test(value);
				}
			)
			.test(
				"no-multiple-spaces",
				trans("Name cannot contain multiple spaces in a row"),
				(value) => {
					if (typeof value !== "string") return false;
					return !/ {2,}/.test(value);
				}
			),
		email: Yup.string()
			.matches(
				/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|[a-zA-Z]{2,})$/,
				trans("Email must be a valid email address with a valid domain")
			)
			.email(trans("Invalid email format"))
			.required(trans("Email is required")),

		password: passwordValidation(),
		phoneNumber: Yup.string()
			.nullable()
			.test("not-empty", trans("Phone cannot be just whitespace"), (val) => {
				if (!val) return true;
				return val.trim().length > 0;
			}),
		address: Yup.string()
			.min(3, trans("Address must be at least 3 characters"))
			.max(256, trans("Address must be at most 256 characters"))
			.test(
				"no-leading-space",
				trans("Address cannot start with a space"),
				(value) => {
					if (!value) return true; // allow null or empty
					return !/^\s/.test(value);
				}
			)
			.test(
				"no-multiple-spaces",
				trans("Address cannot contain multiple spaces in a row"),
				(value) => {
					if (!value) return true; // allow null or empty
					return !/ {2,}/.test(value);
				}
			)
			.nullable(),
		contactPerson: Yup.object()
			.shape({
				name: Yup.string()
					.nullable()
					.min(3, trans("Name must be at least 3 characters"))
					.max(20, trans("Name must be at most 20 characters"))
					.test("not-empty", trans("Name cannot be just whitespace"), (val) => {
						if (!val) return true;
						return val.trim().length > 0;
					}),
				email: Yup.string()
					.matches(
						/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/,
						trans("Email must be a valid email address with a valid domain")
					)

					.email()
					.nullable(),
				phone: Yup.string()
					.nullable()
					.test(
						"not-empty",
						trans("Phone cannot be just whitespace"),
						(val) => {
							if (!val) return true;
							return val.trim().length > 0;
						}
					),
			})
			.test(
				"all-or-none",
				trans("If any contact person field is filled, all must be provided"),
				function (value) {
					if (!value) return true;

					const { name, email, phone } = value;
					const anyFilled = name || email || phone;
					const allFilled =
						!!name?.toString().trim() &&
						!!email?.toString().trim() &&
						!!phone?.toString().trim();

					// If one is filled but not all → error
					if (anyFilled && !allFilled) {
						return this.createError({
							message: trans(
								"All contact person fields are required if one is filled"
							),
						});
					}

					return true;
				}
			)
			.nullable(),
		taxId: Yup.string()
			.max(50, trans("Tax ID cannot exceed 50 characters"))
			.nullable(),
	});

	const addUser = useFormik({
		initialValues,
		validationSchema: validSchema,
		enableReinitialize: true,
		onSubmit: async (val) => {
			console.log("Val", val);
			try {
				if (
					val.contactPerson?.name === "" ||
					val.contactPerson?.email === "" ||
					val.contactPerson?.phone === ""
				) {
					val.contactPerson = null;
				}
				if (isEditing) {
					let newVal = { ...val };

					const keysToDelete = [
						"createdAt",
						"createdBy",
						"updatedAt",
						"updatedBy",
						"updatedById",
						"createdById",
						"tc_user",
						"tc_user_id",
						"id",
					];

					keysToDelete.forEach((key) => {
						if (key in newVal) delete newVal[key];
					});

					let EditedUser = await EditUser({
						id: currentCustomerId,
						val: newVal,
					}).unwrap();
					toast.success(trans("Customer Is Edited Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					// Call onSuccess only on success

					onSuccess && (await onSuccess(EditedUser));
					refetch();

					setReloadData(true);
					handleClose("form");
				} else {
					let InsertedUser = await InsertCustomer(val).unwrap();
					toast.success(trans("Customer Is Added Successfully"), {
						autoClose: 800,
						rtl: localStorage.getItem("lang") === "ar" ? true : false,
					});
					// if (inf.administrator || (inf.deviceLimit > 0 && inf.userLimit > 0)) {
					// 	await AddPermission({
					// 		userId: inf.id,
					// 		managedUserId: InsertedUser.id,
					// 	}).unwrap();
					// }
					onSuccess && (await onSuccess(InsertedUser)); // Call onSuccess only on success
					setReloadData(true);
					handleClose("form");
				}
			} catch (error) {
				toast.error(trans(error?.data.message), {
					autoClose: 800,
					rtl: localStorage.getItem("lang") === "ar" ? true : false,
				});
			}
		},
	});
	const step = steps?.findIndex((i) => i?.value === activeOption);

	const disableNext = () => {
		if (step === 0) {
			if (
				!isEditing &&
				(addUser.values.name === null ||
					addUser.values.email === null ||
					addUser.values.password === null ||
					addUser.errors.name ||
					addUser.errors.email ||
					addUser.errors.password ||
					addUser.errors.contactPerson?.name ||
					addUser.errors.contactPerson?.email)
			) {
				return true;
			} else if (
				!isEditing &&
				(addUser.values.name === null ||
					addUser.values.email === null ||
					addUser.errors.name ||
					addUser.errors.email ||
					addUser.errors.contactPerson?.name ||
					addUser.errors.contactPerson?.email)
			) {
				return true;
			}
		} else if (step === 1 && addUser.errors.address) {
			return true;
		} else {
			return false;
		}
	};
	console.log("AddUser", addUser);
	let disable = disableNext();
	useEffect(() => {
		if (isEditing && Editvalues) {
			addUser.setValues(Editvalues);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Editvalues]);
	const handleSubmit = (e) => {
		setSubmitAttempt(true);
		addUser.handleSubmit(e);
	};

	if (AddLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	if (EditLoading)
		return (
			<div className="loader-container">
				<Loader />
			</div>
		);
	return (
		<>
			<Segmented
				options={steps.map((i, index) => ({
					label: i.label,
					value: i.value,
				}))}
				style={{ textTransform: "capitalize" }}
				onChange={(value) => {
					console.log("Value", value);
					if (!disable) setActiveOption(value);
					if (value === "information" || activeOption === "information") {
						addUser.setFieldTouched("name", true, true);
						addUser.setFieldTouched("email", true, true);
						addUser.setFieldTouched("password", true, true);
						addUser.validateField("name");
						addUser.validateField("email");
						addUser.validateField("password");
					}
				}}
				onClick={(value) => {
					if (value === "information" || activeOption === "information") {
						addUser.setFieldTouched("name", true, true);
						addUser.setFieldTouched("email", true, true);
						addUser.setFieldTouched("password", true, true);
						addUser.validateField("name");
						addUser.validateField("email");
						addUser.validateField("password");
					}
				}}
				value={activeOption}
				size="large"
				block
			/>
			<OffcanvasBody dir={!isRTL ? "ltr" : "rtl"}>
				{activeOption === "information" && <CustomerInfo addData={addUser} />}
				{activeOption === "location setup" && (
					<CustomerLocation addData={addUser} />
				)}
				{activeOption === "extra" && <CustomerExtra addData={addUser} />}
			</OffcanvasBody>
			{/* <UserInfo addData={addUser} /> */}
			<form onSubmit={handleSubmit} dir={!isRTL ? "ltr" : "rtl"}>
				<StepsOffcanvasFooter
					step={steps?.findIndex((i) => i?.value === activeOption)}
					totalsteps={steps?.length - 1}
					setActiveOption={setActiveOption}
					segment={steps}
					addData={addUser}
					submitAttempt={submitAttempt}
					handleSubmit={handleSubmit}
					disableNext={disableNext}
				/>{" "}
			</form>
		</>
	);
}
